import React, { Component } from 'react';
import { DayPickerRangeController } from 'react-dates';
import moment from 'moment';
import { Button, ButtonPrimary, ButtonTertiary } from '@spotify-internal/encore-creator-web';
import { DataRange } from '../../types';

import './_datepicker.css';

import styles from './index.module.scss';
import { FormattedMessage } from 'react-intl';

type Props = {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
  onSave({
    startDate,
    endDate,
    label,
  }: {
    startDate: moment.Moment;
    endDate: moment.Moment;
    label: string;
  }): void;
  onCancel(): void;
  datesAvailable: DataRange;
};

type State = {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
  focusedInput: string;
};

export class Calendar extends Component<Props, State> {
  constructor(props) {
    super(props);
    const { startDate, endDate } = props;
    this.state = { startDate, endDate, focusedInput: 'startDate' };
  }

  onFocusChange = focusedInput => {
    this.setState({
      // Force the focusedInput to always be truthy so that dates are always selectable
      focusedInput: !focusedInput ? 'startDate' : focusedInput,
    });
  };

  render() {
    const { startDate, endDate, focusedInput } = this.state;
    const { onSave, onCancel, datesAvailable } = this.props;

    if (!startDate || !endDate) return null;

    return (
      <div className={styles.parent}>
        <DayPickerRangeController
          numberOfMonths={2}
          onFocusChange={this.onFocusChange}
          focusedInput={focusedInput}
          startDate={startDate}
          endDate={endDate}
          onDatesChange={dates => this.setState(dates)}
          isOutsideRange={day =>
            day.isAfter(moment(datesAvailable.until), 'day') ||
            day.isBefore(datesAvailable.from, 'day')
          }
          initialVisibleMonth={() => moment(endDate).subtract(1, 'month')}
        />
        <div className={styles.buttonContainer}>
          <ButtonTertiary
            condensed
            buttonSize={Button.sm}
            onClick={onCancel}
            className={styles.cancelButton}
          >
            <FormattedMessage id="calendar.cancel" defaultMessage="Cancel" />
          </ButtonTertiary>
          <ButtonPrimary
            buttonSize={Button.sm}
            onClick={() =>
              onSave({
                startDate,
                endDate: endDate || startDate,
                label: `${startDate.format('D MMM YYYY')} - ${endDate.format('D MMM YYYY')}`,
              })
            }
          >
            <FormattedMessage id="calendar.save" defaultMessage="Save" />
          </ButtonPrimary>
        </div>
      </div>
    );
  }
}
